import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  LabelList,
} from "recharts";

// Custom label renderer to skip 0 values
function renderCustomizedLabel({ x, y, width, height, value }) {
  if (!value || value === 0) return null; // skip 0 labels
  return (
    <text
      x={x + width / 2}
      y={y + height / 2}
      textAnchor="middle"
      dominantBaseline="central"
      fill="#fff"
      fontSize={11}
    >
      {value}
    </text>
  );
}

export default function AttendanceSummaryDetailChart({ summary }) {
  // Dynamic height: 50px per player, min 400px
  const chartHeight = Math.max(400, summary.length * 50);

  return (
    <div className="w-full" style={{ height: chartHeight }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={summary}
          layout="vertical"
          barCategoryGap="25%"
          barGap={5}
          margin={{ top: 10, right: 10, left: 0, bottom: 50 }}
        >
          <XAxis type="number" />
          <YAxis
            dataKey="name"
            type="category"
            tick={{ fontSize: 12 }}
            width={100}
          />
          <Tooltip />
          <Legend
            verticalAlign="bottom"
            align="center"
            wrapperStyle={{ paddingTop: 20 }}
          />
          <Bar dataKey="present" stackId="a" fill="#16a34a" name="Present">
            <LabelList dataKey="present" content={renderCustomizedLabel} />
          </Bar>
          <Bar dataKey="late" stackId="a" fill="#f97316" name="Late">
            <LabelList dataKey="late" content={renderCustomizedLabel} />
          </Bar>
          <Bar dataKey="absent" stackId="a" fill="#dc2626" name="Absent">
            <LabelList dataKey="absent" content={renderCustomizedLabel} />
          </Bar>
          <Bar dataKey="mc" stackId="a" fill="#3b82f6" name="MC">
            <LabelList dataKey="mc" content={renderCustomizedLabel} />
          </Bar>
          <Bar dataKey="tournament" stackId="a" fill="#9333ea" name="Tournament">
            <LabelList dataKey="tournament" content={renderCustomizedLabel} />
          </Bar>
          <Bar dataKey="emergency" stackId="a" fill="#ec4899" name="Emergency">
            <LabelList dataKey="emergency" content={renderCustomizedLabel} />
          </Bar>
          <Bar dataKey="event" stackId="a" fill="#22c55e" name="Event">
            <LabelList dataKey="event" content={renderCustomizedLabel} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
